export enum EResetStatus {
	LOADING,
	EXPIRED,
	INVALID_LINK,
	LINK_USED_BEFORE,
	VALID,
	CHANGED_SUCCESSFULLY,
}

export type TForgotPasswordForm = {
	email: string;
};

export interface TResetPasswordForm {
	password: string;
	password_confirmation: string;
	token: string;
}
